import { EPGReport } from './EPGReport';

export * from './EPGReport';
export default EPGReport;
